module.exports = __webpack_public_path__ + "static/img/ag-logo.c9b3e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ag-logo.png
// module id = EEKM
// module chunks = 4